import { graphql } from '../../__generated__';

export const DELETE_ASSET_FROM_WATCHLIST = graphql(`
  mutation DeleteAssetFromWatchList($assetId: Int!) {
    deleteAssetFromWatchList(assetId: $assetId)
  }
`);
